import React from "react";
import { useIntl } from "../../i18n";
import { Tooltip } from "../tooltips/tooltip";
import SmFollow from "./sm-follow";

interface FooterIcon { img: string; title: string; url: string; region?: string }

function FooterLogoList({ icons }: { icons: FooterIcon[] }) {
  return (
    <section className="section section-padding page-footer-logos">
      {icons.map((icon, i) => (
        <div className="footer-logo" key={i}>
          <Tooltip label={icon.title}>
            <a
              href={icon.url}
              rel="noopener noreferrer"
              target="_blank"
              className="footer-logo-link avoid-external-icon"
            >
              <img
                className="footer-logo-img"
                alt={icon.title}
                src={`/images/pro/footer/${icon.img}`}
              />
            </a>
          </Tooltip>
          {icon.region && <SmFollow region={icon.region} />}
        </div>
      ))}
    </section>
  );
}

export default function FooterLogos() {
  const intl = useIntl();
  const icons = config.footer.icons as FooterIcon[];
  // Lauegi: collaborators (config.footer.business) under their own heading
  const business = (config.footer.business ?? []) as FooterIcon[];
  return (
    <>
      <FooterLogoList icons={icons} />
      {business.length > 0 && (
        <>
          <section className="section section-padding">
            <h2 style={{ textAlign: "center" }}>
              {intl.formatMessage({ id: "footer:collab:title" })}
            </h2>
          </section>
          <FooterLogoList icons={business} />
        </>
      )}
    </>
  );
}
